import { ArrowDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function Hero() {
  const { t } = useLanguage();

  const scrollToTable = () => {
    document.getElementById('vergleich')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#020817]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/assets/hero-bg.jpg"
          alt=""
          className="w-full h-full object-cover opacity-15"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#020817]/60 via-[#020817]/80 to-[#020817]" />
        {/* Subtle grid */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(rgba(0,188,212,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,188,212,0.04) 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        />
        {/* Top glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[350px] rounded-full bg-cyan-500/10 blur-[120px]" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center pt-20">
        {/* Badge */}
        <div
          data-testid="hero-badge"
          className="inline-flex items-center gap-2 px-4 py-2 bg-slate-800/80 backdrop-blur-sm border border-slate-700 rounded-full text-sm text-slate-300 mb-8"
        >
          <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
          {t.hero.badge}
        </div>

        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src="/assets/logo.png"
            alt="Hosting-Community"
            className="h-28 w-auto md:h-36"
            style={{ filter: 'brightness(1.4) drop-shadow(0 0 20px rgba(0,188,212,0.45))' }}
          />
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight leading-none mb-6">
          <span className="text-white">{t.hero.headline_1}</span>
          <br />
          <span className="text-cyan-400">{t.hero.headline_2}</span>
        </h1>

        {/* Subtitle */}
        <p className="text-base md:text-lg text-slate-400 max-w-2xl mx-auto mb-10 leading-relaxed">
          {t.hero.sub}
        </p>

        {/* CTA Button */}
        <button
          onClick={scrollToTable}
          data-testid="hero-cta-btn"
          className="inline-flex items-center gap-2 px-8 py-4 bg-cyan-500 text-slate-950 font-semibold rounded-xl hover:bg-cyan-400 transition-colors shadow-[0_0_30px_rgba(0,188,212,0.35)] hover:shadow-[0_0_40px_rgba(0,188,212,0.5)]"
        >
          {t.hero.cta}
          <ArrowDown className="w-5 h-5" />
        </button>

        {/* Stats */}
        <div className="grid grid-cols-3 max-w-xs mx-auto mt-16 gap-6">
          {t.hero.stats.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-cyan-400 font-mono">
                {stat.value}
              </div>
              <div className="text-xs text-slate-500 mt-1 uppercase tracking-wide">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll arrow */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ArrowDown className="w-5 h-5 text-slate-600" />
      </div>
    </section>
  );
}
